import { Search } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/shared/ui/kit/button";
import { CommandShortcut } from "@/shared/ui/kit/command";

type NavSearchProps = {
  onOpen: () => void;
  isMac: boolean;
};

export function NavSearch({ onOpen, isMac }: NavSearchProps) {
  const { t } = useTranslation();

  return (
    <Button variant="secondary" onClick={onOpen} className="gap-2 px-3 h-8">
      <div className="flex items-center gap-2">
        <Search className="w-4 h-4" />
        <span>{t("search.searchPlaceholder")}</span>
      </div>
      <CommandShortcut className="pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground opacity-100">
        {isMac ? "⌘" : "Ctrl"}K
      </CommandShortcut>
    </Button>
  );
}
